import { Paper } from '@material-ui/core';
import { Container, Box } from '@chakra-ui/react';

import { createWhatsappUrl } from 'src/utils/whatsapp';
import whatsImg from 'src/img/whats.svg';

const ContactToModify = () => {
  const message =
    'Olá, sou fornecedor e preciso de ajuda para editar meus produtos no portal.';

  const supportUrl = createWhatsappUrl({ message });

  return (
    <Container maxW="992px">
      <Paper variant="outlined" className="mt-5 mb-5">
        <div className="column d-flex align-items-center m-3 justify-content-between">
          <div className="fw-bold fw-light text-secondary">
            Para modificar informações adicionais dos seus produtos entre em{' '}
            <a href={supportUrl} target="_blank" rel="noreferrer">
              {' '}
              contato com nosso time de suporte aqui
            </a>
          </div>
          <Box>
            <a href={supportUrl} target="_blank" rel="noreferrer">
              <img src={whatsImg} alt="WhatsApp icon" />
            </a>
          </Box>
        </div>
      </Paper>
    </Container>
  );
};

export default ContactToModify;
